import {autoserializeAs, autoserializeAsMap, autoserializeUsing} from "dcerialize";
import type {DateTime} from "luxon";
import {DateTimeSerializer} from "../helpers/DateSerializers";

/**
 * @sealed
 */
export class SystemInformation {
  @autoserializeAs(() => String)
  public readonly version?: string;
  @autoserializeAs(() => String)
  public readonly environment?: string;
  @autoserializeUsing(DateTimeSerializer)
  public readonly timestamp: DateTime<true>;
  @autoserializeAsMap(() => String, () => SystemInformation)
  public readonly subSystems: Map<string, SystemInformation>;
}
